import React, { useRef, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// Use process.env for compatibility with Create React App and Webpack
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN || '';

const MapboxMap = ({
  markers = [],
  center = [-88.088, 36.058],
  zoom = 13,
  height = '400px',
  fitBounds = false,
}) => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (map.current) return;
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center,
      zoom,
    });
  }, []);

  useEffect(() => {
    if (!map.current || !markers.length) return;

    markers.forEach(({ id, coordinates, name, onClick }) => {
      const el = document.createElement('div');
      el.className = 'map-marker';
      el.style.background = '#3B82F6';
      el.style.borderRadius = '50%';
      el.style.width = '18px';
      el.style.height = '18px';
      el.style.cursor = 'pointer';
      el.title = name;

      el.addEventListener('click', () => onClick?.(id));

      new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map.current);
    });

    if (fitBounds && markers.length > 1) {
      const bounds = new mapboxgl.LngLatBounds();
      markers.forEach(({ coordinates }) => bounds.extend(coordinates));
      map.current.fitBounds(bounds, { padding: 60 });
    }
  }, [markers]);

  return <div ref={mapContainer} style={{ width: '100%', height }} />;
};

export default MapboxMap;
